import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            软件分类导航
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            按设备和需求快速找到适合你的免费看片软件
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 flex-shrink-0 group-hover:bg-primary-100 transition-colors">
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base font-semibold text-foreground-950 mb-1 group-hover:text-primary-500 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-2">
                    {cat.description}
                  </p>
                  <span className="text-xs text-foreground-400">
                    {cat.articleCount} 篇文章
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}